module.exports = __webpack_public_path__ + "static/media/button .f06486e4.png";